import { Quote } from './types';

// A revision has a new identity. It must not enter the saved quote list until
// persistence succeeds: that list also determines the editor's save safeguards.
export function createQuoteRevision(old: Quote, id = crypto.randomUUID(), now = new Date().toISOString()): Quote {
  const copy = JSON.parse(JSON.stringify(old));
  return { ...copy, id, status: 'DRAFT', quote_number: undefined, createdAt: now,
    ghl_opportunity_id: (old as any).ghl_opportunity_id || null };
}
